"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _MoreVert = _interopRequireDefault(require("@mui/icons-material/MoreVert"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _Collapse = _interopRequireDefault(require("@mui/material/Collapse"));
var _ExpandLess = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _ListItemSecondaryAction = _interopRequireDefault(require("@mui/material/ListItemSecondaryAction"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _context8 = _interopRequireDefault(require("../App/context"));
var _withMaterial = require("../Template/withMaterial");
var _materialStyle = _interopRequireDefault(require("./materialStyle"));
var _getUtils = _interopRequireDefault(require("wapplr-react/dist/common/Wapp/getUtils"));
var _excluded = ["menu"];
var style = require("./style_css.js")["default"];
function defaultSort(a, b) {
  var aO = a.order || 0;
  var bO = b.order || 0;
  return aO > bO ? 1 : aO < bO ? -1 : 0;
}
function GenerateMenuFunc(props) {
  var appContext = props.appContext,
    context = props.context,
    store = props.store;
  var wapp = context.wapp,
    req = context.req;
  var utils = (0, _getUtils["default"])(context);
  var storage = appContext.storage;
  var menu = props.menu,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var ItemComponent = rest.ItemComponent,
    menuComponentProps = rest.menuComponentProps,
    parentRoute = rest.parentRoute,
    menuProperties = rest.menuProperties,
    onClick = rest.onClick,
    style = rest.style,
    materialStyle = rest.materialStyle,
    _rest$menuKey = rest.menuKey,
    menuKey = _rest$menuKey === void 0 ? "menu_0" : _rest$menuKey;
  var initialState = typeof window !== "undefined" && window[wapp.config.appStateName] || {
    req: {
      timestamp: Date.now()
    }
  };
  var firstRender = utils.getGlobalState("req.timestamp") === initialState.req.timestamp || wapp.target === "node";
  var _useState = (0, _react.useState)(firstRender ? false : store !== null && store !== void 0 && store[menuKey] ? store[menuKey] : false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    open = _useState2[0],
    _setOpen = _useState2[1];
  function setOpen(_x) {
    return _setOpen2.apply(this, arguments);
  }
  function _setOpen2() {
    _setOpen2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(value !== open)) {
              _context2.next = 4;
              break;
            }
            if (storage) {
              storage((0, _defineProperty2["default"])({}, menuKey, value));
            }
            _context2.next = 4;
            return _setOpen(value);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _setOpen2.apply(this, arguments);
  }
  var name = typeof menu.name == "function" ? menu.name(menuProperties) : menu.name;
  var target = menu.target || "_self";
  var href = typeof menu.href == "function" ? menu.href(menuProperties) : menu.href ? menu.href : "";
  var disableParentRoute = menu.disableParentRoute;
  var Icon = menu.Icon;
  var show = menu.role ? menu.role(menuProperties) : true;
  var inner = !(target === "_blank" || href && href.slice(0, 7) === "http://" || href && href.slice(0, 8) === "https://");
  var paddingLeft = menu.paddingLeft;
  var className = typeof menu.className == "function" ? menu.className((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, menuProperties), {}, {
    style: style
  })) : menu.className;
  var menuProps = typeof menu.props == "function" ? menu.props((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, menuProperties), {}, {
    style: style
  })) : menu.props;
  var Element = menu.Element;
  var _ref = menuProps || {},
    itemTextProps = _ref.itemTextProps,
    itemProps = _ref.itemProps;
  (0, _react.useEffect)(function () {
    var newOpenState = store !== null && store !== void 0 && store[menuKey] ? store[menuKey] : false;
    if (newOpenState !== open) {
      _setOpen(newOpenState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (menu.divider && show) {
    return /*#__PURE__*/_react["default"].createElement(_Divider["default"], null);
  }
  if (Element && show) {
    return /*#__PURE__*/_react["default"].createElement(Element, null);
  }
  if (show) {
    var _menu$items, _clsx, _menu$items3, _menu$items4, _menu$items5;
    var hrefWithParentRoute = inner ? disableParentRoute ? href : parentRoute + href : href;
    var isSelected = menu.isSelected ? menu.isSelected((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, menuProperties), {}, {
      inner: inner,
      hrefWithParentRoute: hrefWithParentRoute
    })) : inner && hrefWithParentRoute === req.wappRequest.path;
    var menuItems = (_menu$items = menu.items) !== null && _menu$items !== void 0 && _menu$items.length ? (0, _toConsumableArray2["default"])(menu.items).sort(defaultSort) : [];
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ItemComponent, Object.assign({
      ref: props.forwardedRef,
      component: "a",
      target: target,
      href: hrefWithParentRoute,
      onClick: /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(e) {
          var _menu$items2;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!((_menu$items2 = menu.items) !== null && _menu$items2 !== void 0 && _menu$items2.length)) {
                  _context.next = 5;
                  break;
                }
                e.preventDefault();
                _context.next = 4;
                return setOpen(!open);
              case 4:
                return _context.abrupt("return");
              case 5:
                _context.next = 7;
                return onClick(e, menu);
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }(),
      className: (0, _clsx3["default"])(materialStyle.listItem, (_clsx = {}, (0, _defineProperty2["default"])(_clsx, className, className), (0, _defineProperty2["default"])(_clsx, style.selectedMenu, isSelected), _clsx))
    }, paddingLeft ? {
      sx: {
        pl: paddingLeft
      }
    } : {}, itemProps ? itemProps : {}), Icon ? /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
      className: (0, _clsx3["default"])(materialStyle.listItemIcon, style.listItemIcon)
    }, /*#__PURE__*/_react["default"].createElement(Icon, {
      color: isSelected ? "secondary" : "initial"
    })) : null, /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], Object.assign({
      className: (0, _clsx3["default"])((0, _defineProperty2["default"])({}, style.collapseButtonLabel, (_menu$items3 = menu.items) === null || _menu$items3 === void 0 ? void 0 : _menu$items3.length)),
      primary: name
    }, itemTextProps ? itemTextProps : {}, {
      secondary: itemTextProps !== null && itemTextProps !== void 0 && itemTextProps.secondary ? /*#__PURE__*/_react["default"].createElement("div", {
        className: style.listItemSecondaryText
      }, itemTextProps.secondary) : null
    })), (_menu$items4 = menu.items) !== null && _menu$items4 !== void 0 && _menu$items4.length ? /*#__PURE__*/_react["default"].createElement(_ListItemSecondaryAction["default"], {
      className: style.collapseIcon
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      edge: "end",
      "aria-label": "open",
      onClick: function onClick() {
        return setOpen(!open);
      }
    }, open ? /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null))) : null, isSelected ? /*#__PURE__*/_react["default"].createElement("div", {
      className: style.selectedMark
    }) : null), (_menu$items5 = menu.items) !== null && _menu$items5 !== void 0 && _menu$items5.length ? /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      "in": open,
      className: style.collapseContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: style.collapse
    }, /*#__PURE__*/_react["default"].createElement(_List["default"], Object.assign({}, menuComponentProps, {
      sx: {
        pl: paddingLeft ? paddingLeft : 0
      },
      component: "div",
      disablePadding: true
    }), (0, _toConsumableArray2["default"])(menuItems.map(function (m, k) {
      return /*#__PURE__*/_react["default"].createElement(GenerateMenu, Object.assign({
        menu: m,
        key: "menu_collapse_item_" + k
      }, rest, {
        menuKey: menuKey + k
      }));
    }))))) : null);
  }
  return null;
}
var GenerateMenu = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(GenerateMenuFunc, Object.assign({}, props, {
    forwardedRef: ref
  }));
});
function Menu(props) {
  var _context$res$wappResp;
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var appContext = (0, _react.useContext)(_context8["default"]);
  var wapp = context.wapp;
  var storage = appContext.storage;
  var store = storage();
  wapp.styles.use(style);
  var _props$parentRoute = props.parentRoute,
    parentRoute = _props$parentRoute === void 0 ? "" : _props$parentRoute,
    _props$materialStyle = props.materialStyle,
    materialStyle = _props$materialStyle === void 0 ? {} : _props$materialStyle,
    list = props.list,
    effect = props.effect,
    _props$menuKey = props.menuKey,
    menuKey = _props$menuKey === void 0 ? "menu" : _props$menuKey,
    _props$MoreIcon = props.MoreIcon,
    MoreIcon = _props$MoreIcon === void 0 ? _MoreVert["default"] : _props$MoreIcon;
  var menuProperties = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, props.menuProperties ? props.menuProperties : {}), {}, {
    appContext: appContext,
    context: context
  });
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var _useState5 = (0, _react.useState)(props.menu || []),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    menu = _useState6[0],
    setMenu = _useState6[1];
  function handleMenuOpen(_x3) {
    return _handleMenuOpen.apply(this, arguments);
  }
  function _handleMenuOpen() {
    _handleMenuOpen = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(e) {
      var currentTarget;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            currentTarget = e.currentTarget;
            if (!props.onClickBefore) {
              _context5.next = 4;
              break;
            }
            _context5.next = 4;
            return props.onClickBefore(e);
          case 4:
            _context5.next = 6;
            return setAnchorEl(currentTarget);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _handleMenuOpen.apply(this, arguments);
  }
  function handleMenuClose() {
    return _handleMenuClose.apply(this, arguments);
  }
  function _handleMenuClose() {
    _handleMenuClose = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return setAnchorEl(null);
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _handleMenuClose.apply(this, arguments);
  }
  function onClick(_x4, _x5) {
    return _onClick.apply(this, arguments);
  }
  function _onClick() {
    _onClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(e, menu) {
      var target, href, disableParentRoute, inner;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            target = menu.target || "_self";
            href = typeof menu.href == "function" ? menu.href(menuProperties) : menu.href ? menu.href : "";
            disableParentRoute = menu.disableParentRoute;
            inner = !(target === "_blank" || href && href.slice(0, 7) === "http://" || href && href.slice(0, 8) === "https://");
            if (inner) {
              e.preventDefault();
            }
            if (!menu.onClickBefore) {
              _context7.next = 8;
              break;
            }
            _context7.next = 8;
            return menu.onClickBefore(menuProperties);
          case 8:
            if (!menu.onClick) {
              _context7.next = 13;
              break;
            }
            if (!(anchorEl !== null && !menu.forceOpenMenu)) {
              _context7.next = 12;
              break;
            }
            _context7.next = 12;
            return setAnchorEl(null);
          case 12:
            return _context7.abrupt("return", menu.onClick(e, menuProperties, setAnchorEl));
          case 13:
            if (inner) {
              wapp.client.history.push((0, _objectSpread2["default"])({
                search: "",
                hash: ""
              }, wapp.client.history.parsePath(disableParentRoute ? href : parentRoute + href)));
              if (anchorEl !== null) {
                setAnchorEl(null);
              }
            }
          case 14:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _onClick.apply(this, arguments);
  }
  var actions = {
    open: handleMenuOpen,
    close: handleMenuClose,
    setMenu: setMenu
  };
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: actions
      });
    }
  });
  var featuredMenus = (0, _toConsumableArray2["default"])(menu.filter(function (menu) {
    return !!(menu.featured && !list);
  })).sort(defaultSort);
  var showFeaturedMenu = (0, _toConsumableArray2["default"])(featuredMenus.filter(function (menu) {
    return menu.role ? menu.role(menuProperties) : true;
  }));
  var moreMenus = (0, _toConsumableArray2["default"])(menu.filter(function (menu) {
    return !(menu.featured && !list);
  })).sort(defaultSort);
  var showMoreMenu = (0, _toConsumableArray2["default"])(moreMenus.filter(function (menu) {
    return menu.role ? menu.role(menuProperties) : true;
  }));
  var MenuComponent = list ? _List["default"] : _Menu["default"];
  var ItemComponent = list ? _ListItem["default"] : _MenuItem["default"];
  var menuComponentProps = list ? {} : (0, _objectSpread2["default"])({
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleMenuClose,
    container: ((_context$res$wappResp = context.res.wappResponse.container) === null || _context$res$wappResp === void 0 ? void 0 : _context$res$wappResp.firstChild) || context.res.wappResponse.container || typeof document !== "undefined" && document.body || undefined
  }, props.menuComponentProps ? props.menuComponentProps : {});
  var generateMenuProps = {
    ItemComponent: ItemComponent,
    menuComponentProps: menuComponentProps,
    parentRoute: parentRoute,
    menuProperties: menuProperties,
    onClick: onClick,
    style: style,
    materialStyle: materialStyle,
    appContext: appContext,
    context: context,
    store: store
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showFeaturedMenu.length ? (0, _toConsumableArray2["default"])(featuredMenus.map(function (menu, key) {
    var target = menu.target || "_self";
    var href = typeof menu.href == "function" ? menu.href(menuProperties) : menu.href ? menu.href : "";
    var Icon = menu.Icon;
    var show = menu.role ? menu.role(menuProperties) : true;
    var onlyIcon = Icon && menu.onlyIcon;
    var inner = !(target === "_blank" || href && href.slice(0, 7) === "http://" || href && href.slice(0, 8) === "https://");
    var Element = menu.Element;
    var name = typeof menu.name == "function" ? menu.name(menuProperties) : menu.name;
    var disableParentRoute = menu.disableParentRoute;
    if (show) {
      if (Element) {
        return /*#__PURE__*/_react["default"].createElement(Element, {
          key: "featured" + key
        });
      }
      if (onlyIcon) {
        return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          key: "featured" + key,
          component: "a",
          color: "inherit",
          onClick: /*#__PURE__*/function () {
            var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(e) {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return onClick(e, menu);
                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function (_x6) {
              return _ref3.apply(this, arguments);
            };
          }(),
          href: inner ? disableParentRoute ? href : parentRoute + href : href,
          target: target
        }, Icon ? /*#__PURE__*/_react["default"].createElement(Icon, null) : null);
      }
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        key: "featured" + key,
        component: "a",
        color: "inherit",
        onClick: /*#__PURE__*/function () {
          var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(e) {
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return onClick(e, menu);
                case 2:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          return function (_x7) {
            return _ref4.apply(this, arguments);
          };
        }(),
        href: inner ? disableParentRoute ? href : parentRoute + href : href,
        variant: "text",
        startIcon: Icon ? /*#__PURE__*/_react["default"].createElement(Icon, null) : null,
        target: target
      }, name);
    }
    return null;
  })) : null, showMoreMenu.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !list ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: style.menu,
    color: "inherit",
    onClick: handleMenuOpen,
    "aria-controls": "post-menu",
    "aria-haspopup": "true",
    "aria-label": "post-menu",
    disabled: props.disabled
  }, /*#__PURE__*/_react["default"].createElement(MoreIcon, null)) : null, /*#__PURE__*/_react["default"].createElement(MenuComponent, Object.assign({
    className: (0, _clsx3["default"])(materialStyle.menu, style.menu),
    id: "post-menu"
  }, menuComponentProps), (0, _toConsumableArray2["default"])(moreMenus.map(function (m, k) {
    return /*#__PURE__*/_react["default"].createElement(GenerateMenu, Object.assign({
      menu: m,
      key: "menu_item_" + k
    }, generateMenuProps, {
      menuKey: menuKey + "_" + k
    }));
  })))) : null);
}
var StyledComponent = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], Menu);
var _default = /*#__PURE__*/_react["default"].memo(StyledComponent, function (prevProps, nextProps) {
  var changes = Object.keys(prevProps).join("|") !== Object.keys(nextProps).join("|");
  if (!changes && prevProps.menuProperties && nextProps.menuProperties) {
    changes = Object.keys(prevProps.menuProperties).join("|") !== Object.keys(nextProps.menuProperties).join("|");
    if (!changes) {
      changes = !!Object.keys(prevProps.menuProperties).filter(function (key) {
        return prevProps.menuProperties[key] !== nextProps.menuProperties[key];
      }).length;
    }
  }
  if (prevProps.menuKey !== nextProps.menuKey || prevProps.menu !== nextProps.menu || prevProps.list !== nextProps.list || prevProps.parentRoute !== nextProps.parentRoute || prevProps.effect !== nextProps.effect) {
    changes = true;
  }
  return !changes;
});
exports["default"] = _default;